// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gradient {\n  background: #7927E0;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent; }\n\n.safari-support-gradient {\n  color: #7927E0; }\n", ""]);
// Exports
module.exports = exports;
